import React, { useEffect, useState } from "react";
import axios from "axios";
import { getTodayDate } from "../../utils/constants";

const ReOrderListTransferModal = ({ onClose, onTransfer }) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const DEPARTMENT_NO = localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
  const BASE_URL = apiPaths[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const [vehicleList, setVehicleList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [filters, setFilters] = useState({
    vehicle: "",
    brand: "",
    category: "",
    subCategory: "",
    supplier: "",
    input: "",
    dateFrom: getTodayDate(),
    dateTo: getTodayDate(),
  });

  const fetchMasterList = async (type, setter) => {
    try {
      const url = `${BASE_URL}/api/MasterCount/${COMPANY_CODE}/${type}/-/-`;
      const response = await axios.get(url);
      setter(response.data || []);
    } catch (err) {
      console.error(`Error fetching ${type}:`, err);
    }
  };

  const fetchSuppliers = async () => {
    try {
      // const url = `${BASE_URL}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${DEPARTMENT_NO}/Suppliers/-/${filters.input}`;

      const url = `${BASE_URL}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${DEPARTMENT_NO}/Suppliers/-/-`;
      const response = await axios.get(url);
      setSupplierList(response.data || []);
    } catch (err) {
      console.error("Error fetching suppliers:", err);
    }
  };

  const fetchTableData = async () => {
    try {
      const params = [
        COMPANY_CODE,
        "-",
        filters.dateFrom,
        filters.dateTo,
        filters.vehicle || "-",
        filters.brand || "-",
        filters.category || "-",
        filters.subCategory || "-",
        "-",
        "-",
      ];
      const url = `${BASE_URL}/api/CRMpurchaseEnqGen/${params.join("/")}`;
      const response = await axios.get(url);
      const data = response.data || [];
      const mappedItems = data.map((row, idx) => ({
        id: idx + 1,
        sino: idx + 1,
        code: row.Code || "",
        description: row.Description || "",
        unit: row.Unit || "",
        stock: row.Stock_Qty ?? 0,
        roQty: row.RO_Qty ?? 0,
        ordQty: row.Cost ?? 0,
        remarks: row.ItemDetails || "",
        supplierModal: row.SupplierCode || "",
        category: row.Category || "",
        isIncluded: true,
      }));
      onTransfer?.(mappedItems);
      onClose();
    } catch (err) {
      console.error("Error fetching table data:", err);
    }
  };

  useEffect(() => {
    fetchMasterList("GROUP", setVehicleList);
    fetchMasterList("SUBGROUP", setBrandList);
    fetchMasterList("CATEGORY", setCategoryList);
    fetchMasterList("SUBCATEGORY", setSubCategoryList);
    fetchSuppliers();
  }, []);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleTransfer = () => {
    fetchTableData();
  };

  return (
    <div className="p-6 space-y-5">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Vehicle</label>
          <select
            value={filters.vehicle}
            onChange={(e) => handleFilterChange("vehicle", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          >
            <option value="">Select Vehicle</option>
            {vehicleList.map((item, idx) => (
              <option key={idx} value={item["GRP CODE"]}>{item.DESCRIPTION}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Brand</label>
          <select
            value={filters.brand}
            onChange={(e) => handleFilterChange("brand", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          >
            <option value="">Select Brand</option>
            {brandList.map((item, idx) => (
              <option key={idx} value={item["GRP CODE"]}>{item.DESCRIPTION}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Category</label>
          <select
            value={filters.category}
            onChange={(e) => handleFilterChange("category", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          >
            <option value="">Select Category</option>
            {categoryList.map((item, idx) => (
              <option key={idx} value={item["GRP CODE"]}>{item.DESCRIPTION}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Sub Category</label>
          <select
            value={filters.subCategory}
            onChange={(e) => handleFilterChange("subCategory", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          >
            <option value="">Select Sub Category</option>
            {subCategoryList.map((item, idx) => (
              <option key={idx} value={item["GRP CODE"]}>{item.DESCRIPTION}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Supplier</label>
          <select
            value={filters.supplier}
            onChange={(e) => handleFilterChange("supplier", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          >
            <option value="">Select Supplier</option>
            {supplierList.map((item, idx) => (
              <option key={idx} value={item.ACCOUNT}>{item.DESCRIPTION}</option>
            ))}
          </select>
        </div>
        {/* <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Input</label>
          <input
            type="text"
            value={filters.input}
            onChange={(e) => handleFilterChange("input", e.target.value)}
            placeholder="Enter value..."
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          />
        </div> */}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">From Date</label>
          <input
            type="date"
            value={filters.dateFrom}
            onChange={(e) => handleFilterChange("dateFrom", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">To Date</label>
          <input
            type="date"
            value={filters.dateTo}
            onChange={(e) => handleFilterChange("dateTo", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          />
        </div>
      </div>

      <div className="flex items-center justify-end gap-3 pt-2 border-t border-gray-200">
        <button
          onClick={onClose}
          className="px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition"
        >
          Cancel
        </button>
        <button
          onClick={handleTransfer}
          className="px-5 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition"
        >
          Transfer
        </button>
      </div>

    </div>
  );
};

export default ReOrderListTransferModal;
